<script lang="ts">
  import BasicPageMetadata from "$lib/BasicPageMetadata.svelte";
</script>

<svelte:head>
  <BasicPageMetadata title="About | Carto Australia Property Data" />
</svelte:head>

<div class="flex flex-grow items-center justify-center p-6">
  <div class="w-2xl">
    <h2 class="mb-1 text-2xl font-bold">About this site</h2>
    <p>
      This site was built by <a href="https://ethan.link" target="_blank"
        >Ethan</a
      >
      as part of my
      <a href="https://carto.au" target="_blank">Carto Australia</a>
      project. You can email me at
      <a href="mailto:contact@carto.au">contact@carto.au</a>.
    </p>
    <h3 class="mt-2 mb-1 text-lg font-bold">Data sources</h3>
    <ul>
      <li>
        <a href="https://www.openstreetmap.org/copyright" target="_blank"
          >OpenStreetMap data</a
        > under Open Data Commons Open Database Licence
      </li>
      <li>
        <a
          href="https://www.nsw.gov.au/departments-and-agencies/department-of-planning-housing-and-infrastructure/nsw-valuer-general"
          target="_blank">NSW Valuer General data</a
        > under Creative Commons BY-NC-ND 4.0 Licence
      </li>
      <li>
        <a
          href="https://www.abs.gov.au/statistics/standards/australian-statistical-geography-standard-asgs-edition-3/jul2021-jun2026/access-and-downloads/digital-boundary-files"
          target="_blank">ABS Digital Boundary Files</a
        > under Creative Commons Attribution 4.0 International Licence
      </li>
    </ul>
  </div>
</div>
